import React, { PropTypes } from "react";
import { FieldArray, Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import { TextInput } from "../../../../../common/form";

import { BILLING_PERIOD } from "../../../enums/ratePeriodTypes";
import clientCoverageTypes from "../enums/clientCoverageTypes";
import { RenderCoverages } from "./";
import { MAX_DECIMAL } from "../../../../../common/Configurations/DecimalConfiguration";

class PriceListTypeCoverage extends React.Component {
  /**
   * Initialize form field values before component mounts.
   * Dispatches 0 to tpaFee and gapFee fields if they are null or undefined.
   */
  componentWillMount() {
    // Iterate over all coverage types and initialize null/undefined fee values to 0
    clientCoverageTypes.forEach((_type) => {
      // Initialize tpaFee if it's null or undefined
      if (this.props.initValues[_type.tpaFee] == null) {
        this.props.changeFieldValue("clientCoverage", _type.tpaFee, 0);
      }

      // Initialize gapFee if it's null or undefined
      if (this.props.initValues[_type.gapFee] == null) {
        this.props.changeFieldValue("clientCoverage", _type.gapFee, 0);
      }
    });
  }

  render() {
    const props = this.props;

    return (
      <div>
        <h3>{<FormattedMessage id="clientCoverages.form.priceListRate" />}</h3>
        {props.ratePeriodType === BILLING_PERIOD.value && (
          <p className="text-primary">
            <FormattedMessage id="clientCoverages.form.warnings.billingPeriodRate" />
          </p>
        )}
        <div className="type-table">
          <div className="row table-header price-list">
            <div className="cell">
              <h5>{<FormattedMessage id="clientCoverages.form.class" />}</h5>
            </div>
            <div className="cell">
              <h5>{<FormattedMessage id="clientCoverages.form.coverage" />}</h5>
            </div>
            <div className="cell">
              <h5>
                {
                  <FormattedMessage
                    id={`clientCoverages.form.invoicedClientRate.${props.ratePeriodType}`}
                  />
                }
                <span className="required"> *</span>
              </h5>
            </div>
            <div className="cell">
              <h5>
                {
                  <FormattedMessage
                    id={`clientCoverages.form.clientRate.${props.ratePeriodType}`}
                  />
                }
                <span className="required"> *</span>
              </h5>
            </div>
            <div className="cell">
              <h5>
                {
                  <FormattedMessage
                    id={`clientCoverages.form.providerRate.${props.ratePeriodType}`}
                  />
                }
              </h5>
            </div>
            <div className="cell">
              <h5>
                {
                  <FormattedMessage
                    id={`clientCoverages.form.tpaFee.${props.ratePeriodType}`}
                  />
                }
                <span className="required"> *</span>
              </h5>
            </div>
            <div className="cell">
              <h5>
                {<FormattedMessage id="clientCoverages.form.gapFee" />}
                <span className="required"> *</span>
              </h5>
            </div>
          </div>
          <div className="row-group">
            {clientCoverageTypes.map((type, index) => {
              const rowClasses = classNames({
                row: true,
                "list-type": true,
                "first-of-group": type.value == "SINGLE",
              });

              return (
                <div className={rowClasses} key={index}>
                  <div className="cell">
                    <p>
                      {<FormattedMessage id="clientCoverages.form.default" />}
                    </p>
                  </div>
                  <div className="cell">
                    <p>{<FormattedMessage id={type.key} />}</p>
                  </div>
                  <div className="cell dollar">
                    <Field
                      id={type.idInvoicedClient}
                      name={type.idInvoicedClient}
                      component={TextInput}
                      label={""}
                      type="absNumber"
                      readOnly={props.readOnly}
                    />
                  </div>
                  <div className="cell dollar">
                    <Field
                      id={type.idClient}
                      name={type.idClient}
                      component={TextInput}
                      type="absNumber"
                      readOnly={props.readOnly}
                      onBlur={props.onChangeClientRate.bind(null, type.idClient)}
                    />
                  </div>
                  <div className="cell dollar">
                    <Field
                      id={type.idProvider}
                      name={type.idProvider}
                      component={TextInput}
                      type="absNumber"
                      readOnly="readonly"
                      fixed={MAX_DECIMAL}
                    />
                  </div>
                  <div className="cell dollar">
                    <Field
                      id={type.tpaFee}
                      name={type.tpaFee}
                      component={TextInput}
                      type="absNumber"
                      readOnly={props.readOnly}
                      fixed={MAX_DECIMAL}
                    />
                  </div>
                  <div className="cell wide-cell dollar">
                    <Field
                      id={type.gapFee}
                      name={type.gapFee}
                      component={TextInput}
                      readOnly={props.readOnly}
                      type="number"
                      fixed={MAX_DECIMAL}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          {props.classes.length > 0 && (
            <FieldArray
              name="prices"
              initValues={props.initValues}
              classList={props.classes}
              component={RenderCoverages}
              props={{ readOnly: props.readOnly }}
              onChangeClientRate={props.onChangeClientRate}
            />
          )}
        </div>
      </div>
    );
  }
}

PriceListTypeCoverage.propTypes = {
  initValues: PropTypes.object,
  classes: PropTypes.array,
  types: PropTypes.array,
  data: PropTypes.array,
  onChangeClientRate: PropTypes.func,
  changeFieldValue: PropTypes.func,
  priceList: PropTypes.array,
  ratePeriodType: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default PriceListTypeCoverage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/priceCalculation/PriceListTypeCoverage.js